module.exports = __webpack_public_path__ + "img/empty.d0933470.png";